import React from "react";
import {
  Camera,
  Map,
  ListTree,
  FileText,
  Languages,
  Mic,
  Plane,
  Users,
  CloudSun,
  Languages as Lang2,
  Quote,
  Compass,
  Target,
} from "lucide-react";
import { SECTIONS } from "@/constants/testIds";

const LEFT = [
  { icon: Camera, label: "Photos" },
  { icon: Map, label: "Maps" },
  { icon: ListTree, label: "Species lists" },
  { icon: FileText, label: "Healthy Country Plans" },
  { icon: Languages, label: "Language resources" },
  { icon: Mic, label: "Audio recordings" },
  { icon: Plane, label: "Drone imagery" },
];

const RIGHT = [
  { icon: Users, label: "Elder observations" },
  { icon: CloudSun, label: "Seasonal indicators" },
  { icon: Lang2, label: "Traditional names" },
  { icon: Quote, label: "Stories approved for sharing" },
  { icon: Compass, label: "Ranger knowledge" },
  { icon: Target, label: "Management priorities" },
];

function Column({ kicker, title, items }) {
  return (
    <div>
      <div className="bm-eyebrow mb-4">{kicker}</div>
      <h3 className="font-serif-display text-3xl md:text-4xl text-[#2D2621] leading-tight">
        {title}
      </h3>
      <ul className="mt-8 divide-y divide-[#E2DACF]">
        {items.map(({ icon: Icon, label }) => (
          <li
            key={label}
            className="flex items-center gap-5 py-4 group"
          >
            <span className="w-10 h-10 rounded-full border border-[#C5B6A3] flex items-center justify-center text-[#6B7A6A] group-hover:text-[#A95A3F] group-hover:border-[#A95A3F] transition-colors">
              <Icon size={16} />
            </span>
            <span className="text-[#2D2621] text-lg">{label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function CommunityProvide() {
  return (
    <section
      id="community-provide"
      data-testid={SECTIONS.communityProvide}
      className="py-24 md:py-32 bg-[#FDFBF7]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mb-16">
          <div className="bm-eyebrow mb-6">Section 07 — Working together</div>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#2D2621]">
            What Communities Can Provide
          </h2>
          <p className="mt-6 text-[#584D45] text-lg leading-relaxed">
            Bush Maps are co-created. Communities bring the materials and the
            living knowledge — we bring the design, ecological synthesis and
            visual craft.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 md:gap-20">
          <Column
            kicker="Materials & Records"
            title="What you bring"
            items={LEFT}
          />
          <Column
            kicker="Living Knowledge"
            title="What only you can share"
            items={RIGHT}
          />
        </div>
      </div>
    </section>
  );
}
